import React from "react";
import  { useState, useEffect } from 'react';
import './classes/FootballAgency.css';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";
import SalespersonSidebar from "./SalespersonSidebar";

const FootballAgency = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [footballDirectors, setFootballDirectors] = useState([]);
    const [blogData, setBlogData] = useState([]);
    const app_url = configData.APP_URL;

    useEffect(() => {

         const footballDirectors = [             
            {
                name: "Dr. Lynn Lashbrook",
                image: "/basic/web/images/agent/picture-1472-1441814769.jpg",
                link: "/agent/dr.-lynn-lashbrook",
                bio: ["SMWW Agency President & Founder","Certified NFL Agent","Former NCAA Athletic Director"]
            },
             {
                name: "Adam Klimek",
                image: "/basic/web/images/agent/picture-1446-1651606105.png",
                link: "/agent/adam-klimek",
                bio: ["SMWW Agency Director"]
            },
             {
                name: "Jeff Brodie",
                image: "/basic/web/images/agent/picture-1071-1452544103.png",
                link: "/agent/jeff-brodie",
                bio: ["SMWW Director of Operations","Certified NFL Agent"]
            }
        ];
        setFootballDirectors(footballDirectors);        
    },[]);

    useEffect(() => {
        Promise.all([
            getagencynewslist()
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    async function getagencynewslist() {
        try {
            const response = await fetch(
                app_url+'smwwblog/getagencynewslist',
                {
                    method: "GET",
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setBlogData(responsedata.data.result);
            }
        } catch (error) {
            console.error(error);
        }finally {
            // Set loading to false after fetch completes (success or error)
        }
    } 
    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="football-agency-banner-main">
            <div className="sports_agent_career_banner jobs_in_sports_banner" style={{"display":"inline-block","width":"100%"}}>
            <img className="medium_sized_image desktop-baseball-banner-img ban-img" src="/basic/web/images/agent/football_agency.png" style={{"width":"100%"}}/>
            <img className="medium_sized_image desktop-soccer-banner-img mobile_ban_img" src="/basic/web/images/agent/mobile_football.png" style={{"width":"100%"}}/>
          <div
            className="img_descp"
            style={{
                color: "white",
                position: "absolute",
                marginTop: "-21%",
                marginLeft: "12%",
                textShadow: "2px 2px 8px black, 0 0 25px black",
                filter: "drop-shadow(2px 2px 0px black)"
            }}
            >
            <h1
                className="h1_img_descp"
                style={{
                fontSize: "3.2vw",
                fontWeight: "bold"
                }}
            >
                SMWW Football Agency
            </h1>

            <h2
                className="h2_img_descp"
                style={{
                fontSize: "1.85vw"
                }}
            >
                An extensive network of Agent Advisors <br />
                 representing football players throughout <br />
                  the world.
            </h2>
            </div>

            </div>
  
            <div id="main" className="football-agency-main">
                <Helmet><title>SMWW Football Agency</title></Helmet>
                <div className="left football-agency-left">
                    <div className="view-content">
                    <h2>Football Directors</h2>
                    <div className="item-list mentors-wrapper">
                    <ul>
                        {/* Desktop Wrapper */}
                        <div className="des_sports_wrapper">
                        {footballDirectors.map((director, index) => (
                            <li
                            key={index}
                            className={`views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                            } ${index === 0 ? "views-row-first" : ""} ${
                                index === footballDirectors.length - 1 ? "views-row-last" : ""
                            }`}
                            >
                            <div className="views-field views-field-picture">
                                <div className="field-content">
                                <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                />
                                </div>
                            </div>

                            <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                <a href={director.link}>{director.name}</a>
                                </div>
                            </div>

                            <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                <ul>
                                    {director.bio.map((item, i) => (
                                    <li key={i}>{item}</li>
                                    ))}
                                </ul>
                                </div>
                            </div>
                            </li>
                        ))}
                        </div>

                        {/* Mobile Wrapper */}
                        <div className="mob_sports_wrapper">
                        {footballDirectors.map((director, index) => (
                            <div
                            key={index}
                            className={index % 2 === 0 
                                ? "mob_sports_wrapper_odd" 
                                : "mob_sports_wrapper_even"}
                            >
                            <li
                                className={`sports_directors_li views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                                } ${index === 0 ? "views-row-first" : ""} ${
                                index === footballDirectors.length - 1 ? "views-row-last" : ""
                                }`}
                            >
                                <div className="views-field views-field-picture">
                                <div className="field-content">
                                    <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                    />
                                </div>
                                </div>

                                <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                    <a href={director.link}>{director.name}</a>
                                </div>
                                </div>

                                <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                    <ul>
                                    {director.bio.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                    </ul>
                                </div>
                                </div>
                            </li>
                            </div>
                        ))}
                        </div>
                    </ul>
                    </div>

                </div>
                </div>
                <div className="center left-center">
                   <div className="football-agency-center">
                        <h1>SMWW Football Agency</h1>
                        <p><strong>The Sports Management Worldwide Football Agency </strong>is a full-service football agency with an extensive network all over the world. SMWW represents football players in the NFL, USFL, and CFL. Our company is composed of former NFL players, NFL scouts, endorsement specialists, statistical experts, experienced NFL agents and most importantly, SMWW's Agent Advisors. Our extensive contacts and relationships throughout the NFL afford all of SMWW Agents the ability to open doors for its clients.</p>
                        <h3><strong>Experienced.</strong></h3>     
                        <p>With over 40&nbsp;years of experience in the sports representation field, we are one of the most established and trusted football agencies in the country. As a sports leader, SMWW Football has developed strong relationships with NFL owners, general managers, coaches and front office personnel from every NFL team. In doing so, we are best positioned to assist our clients&nbsp;in maximizing their opportunity in the NFL, no matter if the client was an undrafted rookie or an established veteran. From hall of famers&nbsp;&amp;&nbsp;the green room, to taking CFL players to the NFL, we've got the expeience that creates success.</p>
                        <h3><strong>Maximizing Opportunities On and Off the Field.</strong></h3>
                        <p>With a long and established presence in the football, SMWW has a wide variety of resources and can offer those services to meet each individual client's needs. SMWW Agents Advisors and alliances work together to focus on maximizing the opportunities for our clients, both on and off the field, in the USA or globally. We are here to give a variety of advice, professional guidance, mentoring, and strategic counseling from a worldwide team of experience. Our&nbsp;clients&nbsp;get&nbsp;the advantage of numerous professional opinions and a wealth of expertise of a large agency, yet the hands-on attention from an individual Agent Advisor.</p>
                        <h3><strong>The Best of Both Worlds.</strong></h3>
                        <p>Sports Management Worldwide&nbsp;Agency&nbsp;provides a&nbsp;"two-for-one"&nbsp;Agent approach. SMWW partners a personalized, enthusiastic, passionate, newly trained Agent Advisor with a highly experienced, certified veteran Agent. We&nbsp;think our clients deserve the best of both worlds, the best professional guidance available and the highest quality and quantity of attention an athlete needs to promote themselves.</p>
                        <h3><strong>A Step Ahead</strong>.</h3>
                        <p>When an athlete is evaluating potential agents to represent them, there are many choices. Sports Management Worldwide is here to guide you and help you make an informed decision that supports what is most important for your individual career. From contract negotiation to product endorsements, to travel arrangements, to athletic training, Sports Management Worldwide wants to be a step ahead of you and assist you with all your important decisions. A professional career can be short or long; either way, SMWW wants to help you make it as successful as possible and help an athlete prepare for their life after sports.</p>
                        <p>While we provide NFL players with the best possible representation in contract negotiation, we also strive to provide the best service and the most personal attention to all of our clients. SMWW Football provides athletes with unparalleled resources, premium contract negotiation, personal service, and extraordinary marketing opportunities.</p>
                                        
                        <div style={{
                            listStyle: "none",
                            boxSizing: "border-box",
                            margin: 0,
                            padding: 0,
                            border: 0,
                            fontFamily: "sans-serif",
                            fontSize: "14px",
                            backgroundColor: "rgb(246, 245, 245)",
                            color: "rgb(255, 0, 0)"
                            }}>
                            <em style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                lineHeight: "18px"
                            }}>
                                 If you are a football player looking for representation, we look forward to discussing your career and finding options available to you. Please complete our
                            </em>
                            <span style={{color: "rgb(0, 0, 0)"}}> </span>
                            <a href="/lookingforagent.php" style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                color: "rgb(33, 61, 134)",
                                fontSize: "14px",
                                fontFamily: "inherit",
                                fontStyle: "inherit",
                                backgroundColor: "rgb(246, 245, 245)",
                                outline: 0,
                                verticalAlign: "baseline"
                            }}>
                                online application
                            </a>
                            <span style={{color: "rgb(0, 0, 0)"}}>. </span>
                            </div>
                           <p>
                        <a
                            className="reddbtnn"
                            href="/agents/football"
                            style={{
                            width: '80%',
                            textAlign: 'center',
                            backgroundImage: 'linear-gradient(rgb(254, 0, 0) 0%, rgb(182, 0, 0) 100%)',
                            backgroundColor: 'rgb(255, 255, 255)',
                            }}
                        >
                            VIEW OUR FOOTBALL AGENTS
                        </a>
                        </p>

                    </div>
                </div>
                <div className="right agent-domain-sports">
                    <AgencySidebar/>
                    <SalespersonSidebar /> 
                    <h2>SMWW Sports Agency News</h2>
                    <div className="agency_blog">
                        <ul className="list-unstyled mb-0">

                            {blogData.slice(0, 5).map((post, index) => (
                            <div key={index}>
                                <li
                                style={{
                                    listStyleType: "none",
                                    listStyle: "outside none"
                                }}
                                >
                                <a href={post.link}>
                                    <img src={post.image} alt={post.title} />
                                </a>

                                <p className="stwwt-post-title">
                                    <a className="post-para" href={post.link}>
                                    {post.title}
                                    </a>
                                    <br />
                                    <a href={post.link}>
                                    <span className="button mr-1 arrow">Read Article</span>
                                    </a>
                                </p>
                                </li>

                                {/* Separator */}
                                {index < blogData.slice(0, 5).length - 1 && <li className="sepline">&nbsp;</li>}
                            </div>
                            ))}

                        </ul>
                    </div>
                </div>
            </div>
            </div>
        )}
        </>
    );
};
export default FootballAgency;